import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import { login } from "../services/accountService";
import { tokenKeyName, apiUrl } from "../config";
import { useCallback } from "react";
// import useForm from "../hooks/useForm";
import handleApiError from "../helpers/handleApiError";
// import { defaultTitle } from "../config.json";
import { Helmet } from "react-helmet";
import { DiliTextCP } from "./Utility/DiliTextCP";
import ShipmentAnalysisTable from "./ShipmentAnalysisTable";
// import ShipmentAnalysisSummary from "./ShipmentAnalysisSummary";
import { getShipmentAnalysisReport } from "../services/deliveryService";
import axios from "axios";
// import { toDate } from "date-fns";
// import fileDownload from "js-file-download";
import jwtDecode from "jwt-decode";
// import XLSX from "xlsx";
import { toast } from "react-toastify";
import { ExportIcon } from "./Utility/Icons/ExportIcon";
import withDocumentTitle from "./withDocumentTitle";

function ShipmentAnalysisReport({ setLoading: setLoadingModal }) {
  const XLSX = require("xlsx");
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);

  const [isLoadingFields, setLoadingFields] = useState(false);
  // const wb = XLSX.utils.book_new();

  // const [deliveryDateLeft, setDeliveryDateLeft] = useState(["2022-01-01"]);
  // const [deliveryDateRight, setDeliveryDateRight] = useState(["2022-01-01"]);
  const [reportType, setReportType] = useState("D");
  // const [showCustomer, setShowCustomer] = useState([]);
  // const [buttonClick, setButtonClick] = useState([]);
  const [orders, setOrders] = useState([]); //was [{}]
  const [onChange, setOnChange] = useState(0);

  const history = useHistory();
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [wasValue, setWasValue] = useState(0);

  function parseCityAndState(item) {
    let response = item.map((i) => i.city + "," + i.state);
    return response;
  }
  const [cityAndState, setCityAndState] = useState("");

  const [, setCustomerInfo] = useState([]);

  const [cityandStateArray, setCityAndStateArray] = useState([]);
  const [routeArray, setRouteArray] = useState([]);

  useEffect(() => {
    (async () => {
      setLoadingFields(true);
      try {
        const response = await axios.get(`${apiUrl}/Customer/GetCityAndStates`);
        const routeResponse = await axios.get(
          `${apiUrl}/Delivery/DeliveryReportPageLoad`
        );
        // console.log("se");
        // console.log(routeResponse.data.route);
        setRouteArray(routeResponse.data.route);

        // console.log(cityAndState);

        // console.log(response.data);
        let placeholder = parseCityAndState(response.data);
        setCityAndStateArray(placeholder);
        var cityState = cityAndState.split(",");
        // console.log(cityState[0]);
        // console.log(cityState[1]);
        const cityAndStateData = await axios.get(
          `${apiUrl}Customer/GetCustomersForCityAndState/?city=${String(
            cityState[0]
          )}&state=${String(cityState[1])}`
        );
        setCustomerInfo(cityAndStateData);

        // console.log(customerInfo);
      } catch (ex) {
        handleApiError(ex, history);
      } finally {
        setLoadingFields(false);
      }
    })();
  }, [cityAndState, history]);

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const response = await axios.get(
  //         `${apiUrl}Delivery/DeliveryReport?fromDate=${deliveryDateLeft}&toDate=${deliveryDateRight}&route=aLL&citySt=${cityAndState}&type=&reportType=${reportType}`
  //       );
  //       setOrders(response.data.queryData);
  //       // console.log("Employees/OnPageLoad Endpoint Hit")
  //     } catch (error) {
  //       console.log(error);
  //       handleApiError(error, history);
  //     }
  //   })();
  // }, [onChange, history]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const handleChangeFromDate = (event) => {
    console.log(event.target.value);

    setFromDate(event.target.value);
  };
  const handleExportClick = useCallback((e) => {
    (async () => {
      e.preventDefault();
      if (orders?.length > 0) {
        setLoadingModal(true);
        try {
          // console.log(invoices);
          //   toast.success(
          //     "Most likely going to keep using backend to generate file like on the order history page. To Discuss"
          //   );
          //need to get excel file itself from backend, filedownload, just
          // fileDownload(invoices, "Invoices - " +new Date().toDateString() +".xlsx");
          const decodedClientUser = jwtDecode(
            localStorage.getItem(tokenKeyName)
          );
          //****TEST THIS ONCE BACKEND IS UPDATED */
          const axios = require("axios");
          // const fs = require("fs");

          const { data } = await getShipmentAnalysisReport(
            fromDate,
            toDate,
            route,
            cityAndState,
            reportType
          );
          // console.log("yolo");
          //fileDownload(data, "ShipmentReport.xlsx");
          const downloadExcel = () => {
            const workSheet = XLSX.utils.json_to_sheet(orders);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(
              workBook,
              workSheet,
              "Shipment Analysis Report"
            );
            let buf = XLSX.write(workBook, {
              bookType: "xlsx",
              type: "buffer",
            });
            XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
            //download
            XLSX.writeFile(workBook, "Shipment Analysis Report.xlsx");
          };
          downloadExcel();
          setLoadingModal(false);
        } catch (ex) {
          setLoadingModal(false);
          // console.log(ex);
          handleApiError(ex, history);
          //   toast.error("Issue Exporting File");
          //   console.log(ex);
        }
      } else {
        toast.error("No orders to export.");
      }
    })();
  });
  const [, setCustomer] = useState([]);
  const [, setCustomerIndex] = useState([]);
  const [route, setRoute] = useState("");
  const handleSelectCityAndState = (e) => {
    setCustomer(""); //when we change city/state, reset customer to blank
    setCustomerIndex("");

    setCityAndState(e.target.value);
  };
  const handleSelectRoute = (e) => {
    setRoute(e.target.value);
  };
  const handleChangeToDate = (event) => {
    setToDate(event.target.value);
    console.log(event.target.value);
  };
  const handleChangeReportType = (event) => {
    console.log(event.target.value);
    setReportType(event.target.value);
  };
  const [totals, setTotals] = useState([]);
  const handleOnSubmit = () => {
    if (fromDate && toDate && route && cityAndState && reportType) {
      setOnChange(onChange + 1);
      setWasSubmitted(true);
      setWasValue(1);
      (async () => {
        // console.log(fromDate);
        // console.log(toDate);
        // console.log(route);
        // console.log(cityAndState);
        // console.log(reportType);

        try {
          setLoading(true);
          setError(false);
          const response = await axios.get(
            `${apiUrl}Delivery/DeliveryReport?fromDate=${fromDate}&toDate=${toDate}&route=${route}&citySt=${cityAndState}&type=s&reportType=${reportType}`
          );
          // console.log("rwar");
          // console.log(response.data);
          setTotals(response.data.queryDataGrandTotal);
          setOrders(response.data.queryData);
          if (response.data.queryData.length <= 0) {
            toast.error("No results found for given parameters");
          }

          setLoading(false);
          // console.log("Employees/OnPageLoad Endpoint Hit")
        } catch (error) {
          setLoading(false);
          setError(true);
          handleApiError(error, history);
        }
      })();
    } else {
      toast.error("Please fill out report parameters.");
    }
  };
  return (
    <div>
      <div className="tw-text-center tw-mb-5 lg:tw-absolute lg:tw-top-0 lg:tw-right-0">
        <div className="tw-flex tw-justify-center tw-gap-x-4 lg:tw-items-center">
          <select
            className="form-control"
            name="reportType"
            onClick={handleChangeReportType}
            style={{ maxWidth: "fit-content", textOverflow: "ellipsis" }}
          >
            <option value="D">Detail</option>
            <option value="S">Summary</option>
          </select>

          <ExportIcon
            role="button"
            className="no-copy"
            size={25}
            alt="Export Orders"
            title="Export Report"
            onClick={handleExportClick}
          />
        </div>
      </div>

      <div className="tw-mb-4 lg:tw-mb-12 lg:tw-mt-8 container">
        <div className="tw-flex tw-flex-col tw-gap-y-3 lg:tw-flex-row lg:tw-justify-evenly lg:tw-items-end lg:tw-gap-x-12">
          <DiliTextCP
            label="Delivery Date From"
            className="tw-flex-1"
            type="date"
            name="fromDate"
            value={fromDate}
            onChange={handleChangeFromDate}
            wasSubmitted={wasSubmitted}
            successfulSubmissionNotif={wasValue}
            required
          />

          <DiliTextCP
            label="Delivery Date To"
            className="tw-flex-1"
            type="date"
            name="fromDate"
            value={toDate}
            onChange={handleChangeToDate}
            wasSubmitted={wasSubmitted}
            successfulSubmissionNotif={wasValue}
            required
          />

          <DiliTextCP
            className="tw-flex-1"
            label="City & State"
            invalidText="Please select a city & state"
            type="select"
            required
            name="cityAndState"
            wasSubmitted={wasSubmitted}
            successfulSubmissionNotif={wasValue}
            value={cityAndState}
            onChange={handleSelectCityAndState}
            disabled={isLoadingFields}
          >
            <option value="">Select City</option>
            <option value="all">All Cities</option>

            {cityandStateArray.map((cityAndStates, index) => {
              return (
                <option key={index + "-" + cityAndStates} value={cityAndStates}>
                  {cityAndStates}
                </option>
              );
            })}
          </DiliTextCP>

          <DiliTextCP
            className="tw-flex-1"
            label="Route"
            wasSubmitted={wasSubmitted}
            successfulSubmissionNotif={wasValue}
            invalidText="Please select a route"
            type="select"
            required
            name="route"
            value={route}
            onChange={handleSelectRoute}
            disabled={isLoadingFields}
          >
            <option value="">Select Route</option>
            <option value="all">All Routes</option>
            {routeArray.map((index) => {
              return (
                <option key={index + "-" + index.route} value={index.route}>
                  {index.route}
                </option>
              );
            })}
          </DiliTextCP>

          <div className="tw-self-center lg:tw-self-auto">
            <button onClick={handleOnSubmit} className="btn btn-primary">
              Search
            </button>
          </div>
        </div>
      </div>

      <ShipmentAnalysisTable
        wasSubmitted={wasSubmitted}
        orders={orders}
        totals={totals}
        type={reportType}
        isLoading={isLoading}
        isError={isError}
      />
    </div>
  );
}

export default withDocumentTitle(ShipmentAnalysisReport, {
  pageTitle: "Shipment Analysis Report",
});
